import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../../components/buttons/Button';
import type { MetagameBingoEvent } from '../../../../../../stores/bingo/types';
import { useBingoWidgetCallbacks } from '../../../../hooks';
import { BingoLiveButtonText } from '../../BingoLiveButtonText/BingoLiveButtonText';
import { BingoWidgetLogo } from '../../BingoWidgetLogo/BingoWidgetLogo';
import { BingoWideWidgetWrapper } from '../BingoWideWidgetWrapper/BingoWideWidgetWrapper';

import styles from './BingoStartingSoonWideWidget.module.scss';

interface BingoStartingSoonWideWidgetProps {
  event: MetagameBingoEvent;
}

export function BingoStartingSoonWideWidget(props: BingoStartingSoonWideWidgetProps) {
  const { event } = props;
  const { t } = useTranslation();
  const { onEnterLiveEventClick } = useBingoWidgetCallbacks();
  const feature = event?.game.isFreeDaubEvent ? 'daub' : 'general';
  const bingoType = event?.coinType === 'GC' ? 'CASUAL' : 'SWEEP';

  return (
    <BingoWideWidgetWrapper
      feature={feature}
      wrapperClassName={styles.wrapper}
      onClick={() => onEnterLiveEventClick(event)}
    >
      <BingoWidgetLogo bingoType={bingoType} sizeType="wide" />
      <div className={styles.content}>
        <div className={styles.topWrapper}>
          <span className={classNames(styles.text, bingoType === 'SWEEP' ? styles.textSweep : styles.textCasual)}>
            {t('prime.lobbyBanner.startingSoon')}
          </span>
        </div>
        <div className={styles.btnWrapper}>
          <Button btnType="purple-blue" className={styles.btn}>
            <BingoLiveButtonText />
          </Button>
        </div>
      </div>
    </BingoWideWidgetWrapper>
  );
}
